export const GUARANTEE_FEE = 'Guarantee fee'
export const AUTO_EXTENSION = 'Auto extension'
export const GUARANTEE_FEE_BY_GOV = 'Guarantee fee by GOV'
